import React from 'react';

import { Text } from 'wanderu-components';
import { localize } from 'wanderu-i18n';
import type { I18nMoneyFunction } from 'wanderu-i18n';

import { LineItem } from '../../LineItem';
import {
    useFormattedTripPricingSelector,
} from '../../hooks';
import { LegInfo } from '../LegInfo';

import styles from './TripLeg.scss';

import type { TripLegItems } from '../../types';

interface TripLegProps extends TripLegItems {
    i18nMoney: I18nMoneyFunction;
}

function TripLeg(props: TripLegProps) {
    const {
        i18nMoney,
        tripId,
        tripModes,
    } = props;

    const {
        totalPrice,
    } = useFormattedTripPricingSelector({ i18nMoney, tripId });

    return (
        <>
            <LineItem
                className={styles.lineItem}
                leftCol={
                    <LegInfo
                        tripId={tripId}
                        tripModes={tripModes}
                    />
                }
                rightCol={
                    <Text>
                        {totalPrice}
                    </Text>
                }
            />
        </>
    );
}

export { TripLeg };
export default localize(TripLeg, ['i18nMoney', 't'], 'baseApp');
